export default __webpack_public_path__ + "38bc29bf900134dd5c169e5642c483aa.svg";